export const milestones = [
  { name: 'Milestone 1', id: '1', amount: { value: '100.00' } },
  { name: 'Milestone 2', id: '2', amount: { value: '200.00' } },
  { name: 'Milestone 3', id: '3', amount: { value: '300.00' } },
  { name: 'Milestone 4', id: '4', amount: { value: '400.00' } },
  { name: 'Milestone 5', id: '5', amount: { value: '500.00' } },
];

export const donors = [
  { name: 'Donor 1', color: 'red', id: 'red1', amount: '100' },
  { name: 'Donor 2', color: 'red', id: 'red2', amount: '200' },
  { name: 'Donor 3', color: 'red', id: 'red3', amount: '200' },
  { name: 'Donor 4', color: 'red', id: 'red4', amount: '300' },
  { name: 'Donor 5', color: 'red', id: 'red5', amount: '4000' },
];

/**
 *
 * @type {import('@playlive/tiltify-lib').TiltifyDonation[]}
 */
export const fakeTiltifyDonors = [
  {
    id: '1',
    donor_name: 'Steve Smith',
    amount: {
      value: '10',
      currency: 'USD'
    },
    cause_id: 'cause-1',
    campaign_id: 'campaign-1',
    completed_at: new Date().toISOString(),
    sustained: false,
    fundraising_event_id: null,
    reward_claims: [],
    reward_id: null,
    target_id: null,
    team_event_id: null,
    donor_comment: null,
    poll_id: null,
    poll_option_id: null,
  },
  {
    id: '2',
    donor_name: 'Paul Smith',
    amount: {
      value: '10',
      currency: 'USD'
    },
    cause_id: 'cause-1',
    campaign_id: 'campaign-1',
    completed_at: new Date().toISOString(),
    sustained: false,
    fundraising_event_id: null,
    reward_claims: [],
    reward_id: null,
    target_id: null,
    team_event_id: null,
    donor_comment: null,
    poll_id: null,
    poll_option_id: null,
  }
]


export const rewards = [
  {
    name: 'Reward 1',
    active: true,
    id: '1',
    quantity: 100,
    quantity_remaining: 2,
    highlighted: false,
    amount: {
      value: '100',
    },
  },
  {
    name: 'Reward 2',
    active: true,
    id: '2',
    quantity: 100,
    quantity_remaining: 10,
    highlighted: true,
    amount: {
      value: '200',
    },
  },
  {
    name: 'Reward 3',
    active: true,
    id: '3',
    quantity: 100,
    quantity_remaining: 9,
    highlighted: false,
    amount: {
      value: '300',
    },
  },
  {
    name: 'Reward 4',
    active: true,
    id: '4',
    quantity: 100,
    quantity_remaining: 80,
    highlighted: true,
    amount: {
      value: '400',
    },
  },
  {
    name: 'Reward 5',
    active: true,
    id: '5',
    quantity: 100,
    quantity_remaining: 20,
    highlighted: false,
    amount: {
      value: '500',
    },
  },
  {
    name: 'Reward 6',
    active: false,
    id: '6',
    quantity: 100,
    quantity_remaining: 20,
    highlighted: false,
    amount: {
      value: '500',
    },
  },
];
export const targets = [
  { name: 'Target 1', color: 'red', id: 'red1', amount: '100' },
  { name: 'Target 2', color: 'red', id: 'red2', amount: '200' },
  { name: 'Target 3', color: 'red', id: 'red3', amount: '200' },
  { name: 'Target 4', color: 'red', id: 'red4', amount: '300' },
  { name: 'Target 5', color: 'red', id: 'red5', amount: '400' },
];

export const fakeTiltifyUser = {
  description: "Test User's description",
  id: 'test-user-id',
  legacy_id: 1,
  slug: 'test-user',
  social: {
    discord: null,
    facebook: null,
    instagram: null,
    snapchat: null,
    tiktok: null,
    twitch: null,
    twitter: null,
    website: null,
    youtube: null,
  },
  total_amount_raised: {
    currency: 'USD',
    value: '125.00',
  },
  url: 'https://tiltify.com/@test-user',
  username: 'test-user',
};

export const fakeTiltifyPoll = {
  active: true,
  amount_raised: {
    currency: 'usd',
    value: '125.00',
  },
  id: 'test-poll-id',
  inserted_at: '2024-10-18T21:44:28.314Z',
  legacy_id: 1,
  name: 'Test Poll',
  options: [
    {
      amount_raised: {
        currency: 'usd',
        value: '100.00',
      },
      id: 'test-poll-option-id-one',
      inserted_at: '2024-10-18T21:44:28.314Z',
      legacy_id: 1,
      name: 'Poll Option One',
      updated_at: '2024-10-18T21:44:28.314Z',
    },
    {
      amount_raised: {
        currency: 'usd',
        value: '25.00',
      },
      id: 'test-poll-option-id-two',
      inserted_at: '2024-10-18T21:44:28.314Z',
      legacy_id: 2,
      name: 'Poll Option Two',
      updated_at: '2024-10-18T21:44:28.314Z',
    },
  ],
  updated_at: '2024-10-18T21:44:28.314Z',
};

export const fakeTiltifyCampaign = {
  amount_raised: {
    currency: 'usd',
    value: '125.00',
  },
  avatar: null,
  cause_id: 'test-cause-id',
  description: 'Description for Test Campaign',
  donate_url: 'https://donate.tiltify.com/test-campaign',
  fundraising_event_id: null,
  goal: {
    currency: 'usd',
    value: '1000.00',
  },
  has_schedule: true,
  id: 'test-campaign-id',
  inserted_at: '2024-10-17T21:05:44.503Z',
  legacy_id: 1,
  livestream: null,
  name: 'Test Campaign',
  original_goal: {
    currency: 'usd',
    value: '500.00',
  },
  published_at: '2024-10-17T21:05:44.503Z',
  retired_at: null,
  slug: 'test-campaign',
  status: 'published',
  supporting_type: 'public',
  total_amount_raised: {
    currency: 'usd',
    value: '125.00',
  },
  updated_at: '2024-10-17T21:05:44.503Z',
  url: 'https://tiltify.com/@test-user/test-campaign',
  user: fakeTiltifyUser,
  user_id: fakeTiltifyUser.id,
};
